/**
 * Program: Mixed in for parameters and menus
 * Author: SDL
 * Description: Resource Management Common
 */

import _ from 'lodash';
import axios from 'axios';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { SDLUtil } from '@/utils';
import Constants from '@/constants/RemConstants';

export default {
  computed: {
    ...mapGetters({
      getRemRole: 'getRemRole',
      getUserPrmsYn: 'getUserPrmsYn',
      getInfraManagerYn: 'getInfraManagerYn',
      divisionCd: 'getDivisionCd',
      getRemDivisionList: 'getRemDivisionList',
    }),

    apiCallSettings() {
      return {
        withCredentials: true,
        origin: true,
        headers: {
          'X-Auth-Token': localStorage.userToken,
          // 'X-Auth-Token':
          'Content-Type': 'application/json',
          'accept-language':false,
          'last-access-time': false,
          'menu-id':false,
          'page-id':false,
          'pragma':false,
          'x-auth-refresh-token':false,
          'original-user-id':false,
        },
        transformResponse: [
          response => {
            const res = JSON.parse(response);
            console.log('@@@ transformResponse:', res);

            if (res.status !== 0 && res.status !== 200) {
              SDLUtil.errorAlert(this.makeErrorMessage(res.message));
            } else if (res.error_code !== 0) {
              SDLUtil.errorAlert(this.makeErrorMessage(res.message));
            }

            return res;
          },
        ],
      };
    },
  },
  methods: {
    makeErrorMessage(msg) {
      return {
        data: {
          error: {
            // reason: data.message,
            reason: msg,
          },
        },
      };
    },

    /**
     * Get 방식 통신
     * @param url :String 호출 URL
     * @param params : {any}
     * @param callback : Function 응답 후 콜백 함수
     * @param errorCallback : Function 에러 콜백 함수
     * @returns {Promise<void>}
     */
    async fetchGet(url, params, callback, errorCallback) {
      SDLUtil.showLoadingBar(true);

      await axios
        .get(`${SDLUtil.API_URL}${url}?${this.encodeQueryData(params)}`)
        .then(({ data }) => {
          SDLUtil.showLoadingBar(false);
          if (data.message !== 'SUCCESS' && data.message !== 'Success' && !_.isEmpty(data.message)) {
            SDLUtil.errorAlert(this.makeErrorMessage(data.message));
            return;
          }
          callback(data);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          errorCallback(err);
        });
    },

    /**
     * Go 서버 Get 방식 통신
     * @param url :String 호출 URL
     * @param params : {any}
     * @param callback : Function 응답 후 콜백 함수
     * @param errorCallback : Function 에러 콜백 함수
     * @returns {Promise<void>}
     */
    async fetchGetToGoLangServer(url, params, callback, errorCallback) {
      // CORS 호출을 위한 세팅
      SDLUtil.showLoadingBar(true);

      let question = '?';

      if (_.isEmpty(params)) {
        question = '';
      }

      await axios
        .get(
          `${SDLUtil.getExternalUrl('GO_SERVER_URL')}${url}${question}${this.encodeQueryData(params)}`,
          this.apiCallSettings,
        )
        .then(res => {
          SDLUtil.showLoadingBar(false);
          if (
            res.status !== Constants.RESPONSES_STATUS.OK ||
            res.data.status !== Constants.GO_API_RESPONCE_SUCCESSFUL
          ) {
            if (!_.isEmpty(res.data.message)) {
              SDLUtil.errorAlert(this.makeErrorMessage(res.data.message));
            } else {
              SDLUtil.errorAlert(this.makeErrorMessage(this.$t('cop.rem.message.error.commonMsg')));
            }

            return;
          }
          callback(res.data);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          errorCallback(err);
        });
    },

    /**
     * 쿼리 파라미터 인코딩
     * @param data : Dictionary
     * @returns : string &key1=value1&&key2=value2 ...
     */
    encodeQueryData(data) {
      if (_.isEmpty(data)) {
        return '';
      }
      const ret = [];

      // Object.entries(data).forEach(key => {
      //   ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
      // });

      for (const [key] of Object.entries(data)) {
        ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
      }

      return ret.join('&');
    },

    /**
     * 쿼리 파라미터 인코딩
     * @param data : Dictionary
     * @returns : string &key1=value1&&key2=value2 ...
     */
    queryData(data) {
      const ret = [];

      // Object.entries(data).forEach(key => {
      //   ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
      // });

      for (const [key] of Object.entries(data)) {
        ret.push(`${key}=${data[key]}`);
      }

      return ret.join('&');
    },

    /**
     * POST 방식 통신
     * @param url : String 호출 URL
     * @param payload : {any} Body에 넘길 파라미터
     * @param callback : Function 응답 후 콜백 함수
     * @param errorCallback : Function 에러 콜백 함수
     * @returns {Promise<void>}
     */
    async fetchPost(url, payload, callback, errorCallback) {
      SDLUtil.showLoadingBar(true);

      if (_.isEmpty(payload)) {
        payload = {};
      }

      await axios
        .post(`${SDLUtil.API_URL}${url}`, payload)
        .then(res => {
          SDLUtil.showLoadingBar(false);
          if (res.data.message !== 'SUCCESS' && res.data.message !== 'Success' && !_.isEmpty(res.data.message)) {
            SDLUtil.errorAlert(this.makeErrorMessage(res.data.message));
          }
          callback(res);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          errorCallback(err);
        });
    },

    /**
     * Go 서버 POST 방식 통신
     * @param url : String 호출 URL
     * @param payload : {any} Body에 넘길 파라미터
     * @param successCallback : Function 응답 후 콜백 함수
     * @param errorCallback : Function 에러 콜백 함수
     * @returns {Promise<void>}
     */
    async fetchPostToGoLangServer(url, payload, successCallback, errorCallback) {
      SDLUtil.showLoadingBar(true);

      if (_.isEmpty(payload)) {
        payload = {};
      }

      await axios
        .post(`${SDLUtil.getExternalUrl('GO_SERVER_URL')}${url}`, JSON.stringify(payload), this.apiCallSettings)
        .then(res => {
          SDLUtil.showLoadingBar(false);

          if (res === undefined) {
            return;
          }

          successCallback(res);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          errorCallback(err);
        });
    },

    async fetchOptionToGoLangServer(url, successCallback, errorCallback) {
      SDLUtil.showLoadingBar(true);

      await axios
        .options(`${SDLUtil.getExternalUrl('GO_SERVER_URL')}${url}`, this.apiCallSettings)
        .then(res => {
          SDLUtil.showLoadingBar(false);

          if (res === undefined) {
            return;
          }
          successCallback(res);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          errorCallback(err);
        });
    },

    // Go Lang CSRF token 포함하는 Post API
    async fetchPostWithCSRFToGoLangServer(url, payload, antiCSRFToken, successCallback, errorCallback) {
      SDLUtil.showLoadingBar(true);

      if (_.isEmpty(payload)) {
        payload = {};
      }

      const setting = this.apiCallSettings;

      setting.headers['Anti-CSRF-Token'] = antiCSRFToken;

      await axios
        .post(`${SDLUtil.getExternalUrl('GO_SERVER_URL')}${url}`, JSON.stringify(payload), this.apiCallSettings)
        .then(res => {
          SDLUtil.showLoadingBar(false);
          if (res === undefined) {
            return;
          }
          successCallback(res);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(this.$t('cop.rem.message.error.commonMsg'));
          errorCallback(err);
        });
    },

    /**
     * 페이징..
     * @param currentPage : int 현재 페이지
     * @param pageSize : int 한페이지에 노출 되는 개수
     * @param rows : Array<Map> Rows
     * @returns pageRows[] : Array<Map> 페이징된 Rows
     */
    pageData(currentPage, pageSize, rows) {
      const pageRows = [];
      let start = (currentPage - 1) * pageSize;
      let end = currentPage * pageSize - 1;

      if (start < 0) start = 0;
      if (end > rows.length - 1) end = rows.length - 1;

      for (let i = start; i <= end; i += 1) {
        pageRows.push(rows[i]);
      }

      return pageRows;
    },

    /**
     * Y이면 N, N이면 Y 리턴
     * @param YN : String
     * @returns {string}
     */
    reverseYN(YN) {
      return YN === 'Y' ? 'N' : 'Y';
    },

    /**
     * 관리자 유무
     * @returns boolean 관리자 유무
     */
    isAdmin() {
      return this.isSystemAdmin() || this.isDivisionAdmin();
    },

    /**
     * 시스템 관리자 유무
     * @returns boolean 관리자 유무
     */
    isSystemAdmin() {
      return this.getRemRole === 'sa';
    },

    /**
     * 사업부 어드민 유무
     * @returns boolean 관리자 유무
     */
    isDivisionAdmin() {
      return this.getRemRole === 'da';
    },

    /**
     * Permission Manager > Resource List 에서만 사용
     * 어드민 또는 (유저이면서 인프라메니져) 유무
     * @returns boolean 관리자 유무
     */
    haveResourceRole() {
      return this.isAdmin() || this.getInfraManagerYn === 'Y';
    },

    /**
     * Permission Manager > Resource List 에서만 사용
     * ProjectOwner 이상권한
     * @returns boolean 관리자 유무
     */
    isAdminOrOwner(row) {
      return this.haveResourceRole() || row.projectOwnerYn === 'Y';
    },

    getMyDivisionCd() {
      return this.divisionCd;
    },

    async checkBlockUser() {
      if (_.isEmpty(this.getRemRole)) {
        await this.$store.dispatch('GET_REM_USER');
      }

      if (this.getUserPrmsYn === 'N') {
        this.openInfoToast('Your account is blocked. Ask the manager.');
        this.$store.commit('SET_REM_ROLE', '');
        this.$store.commit('SET_USER_PRMS_YN', '');
        this.$router.push(`${this.$context}/`);
        return false;
      }
      return true;
    },

    /**
     * 세션 유저 조회
     */
    getUser() {
      return SDLUtil.getLoginedUserInfo();
    },

    /**
     * Date Time 객체에 날짜 형태 맞추기
     * @param prevDate : Date 데이트
     * @param dateTimeObj : Dictionary Date Time 객체
     * @returns Date Time 객체
     */
    getDateTimeinHrs(prevDate, dateTimeObj) {
      const todayDateTime = new Date();
      const diff = prevDate.getTime() - todayDateTime.getTime();

      const resultInMinutes = Math.round(diff / 60000) - prevDate.getTimezoneOffset();
      dateTimeObj.Hrs = Math.floor(resultInMinutes / 60);
      dateTimeObj.Hrs = dateTimeObj.Hrs < 0 ? 0 : dateTimeObj.Hrs;

      dateTimeObj.Minutes = Math.round(resultInMinutes % 60);
      dateTimeObj.Minutes = dateTimeObj.Minutes < 0 ? 0 : dateTimeObj.Minutes;

      let hrStr = ' Hrs ';
      let minuteStr = ' Minutes';

      if (dateTimeObj.Hrs < 2) hrStr = ' Hr ';
      if (dateTimeObj.Minutes < 2) minuteStr = ' Minute';

      dateTimeObj.displayTime = dateTimeObj.Hrs + hrStr + dateTimeObj.Minutes + minuteStr;
    },

    findDomainJoinStatusMap(codeList, errorCodeMap, code) {
      const map = Constants.DOMAIN_JOIN_STATUS_CODES[code];
      let idx = 1;
      let statusIdx = -1;
      let errorIdx = -1;
      let percent = -1;

      codeList.forEach(c => {
        // 정상 코드
        if (code === c) {
          statusIdx = idx;
          percent = ((100 / codeList.length) * statusIdx).toPrecision(5);
        }
        idx += 1;
      });

      // 에러 코드 찾기
      if (statusIdx === -1) {
        if (errorCodeMap[code] !== undefined) {
          errorIdx = codeList.indexOf(errorCodeMap[code], 0) + 1;
          percent = ((100 / codeList.length) * errorIdx).toPrecision(5);
        }
      }

      return { ...map, statusIdx, errorIdx, percent, code, codeMaxLength: codeList.length };
    },

    // 공백제거
    removeSpace(str) {
      return str.split(' ').join('');
    },

    /**
     * 날짜 차이
     * @param startDate : Date 데이트
     * @param endDate : Date 데이트
     * @returns number
     */
    getDateDiff(startDate, endDate) {
      const sDate = new Date(startDate);
      const eDate = new Date(endDate);

      return (eDate.getTime() - sDate.getTime()) / (1000 * 60 * 60 * 24);
    },

    getCspNm(cspCd) {
      const sCsp = SDLUtil.getCommCodeList({ commCodeTypeId: 'REM_CSP_CD' }).find(csp => csp.code === cspCd);
      if (!_.isEmpty(sCsp)) return sCsp.label;
      return cspCd;
    },

    getEnvNm(env) {
      const sEnv = SDLUtil.getCommCodeList({ commCodeTypeId: 'STD_CSP_ENV_CD' }).find(envTag => envTag.code === env);
      if (!_.isEmpty(sEnv)) return sEnv.label;
      return env;
    },
    getResourceType(code) {
      const resourceType = SDLUtil.getCommCodeList({ commCodeTypeId: 'REM_RESOURCE_TYPE' }).find(
        resType => resType.code === code,
      );
      if (!_.isEmpty(resourceType)) return resourceType.label;
      return resourceType;
    },
    getCommCode(type) {
      return SDLUtil.getCommCodeList({ commCodeTypeId: type });
    },

    getCommCodeValue(type, code) {
      const codeMap = SDLUtil.getCommCodeList({ commCodeTypeId: type }).find(c => c.code === code);
      if (!_.isEmpty(codeMap)) return codeMap.label;
      return code;
    },

    setCookie(key, value, expiredDays) {
      // 자동 삭제 날짜를 지정하는 코드
      const today = new Date();
      today.setDate(today.getDate() + expiredDays);
      // 쿠키에 값을 저장
      document.cookie = `${key}=${value}; domain:'aaaaaaaaaaa';  path=/; expires=${today.toGMTString()};`;
    },

    getCookie(key) {
      // 쿠키는 한번에 모두 불러와지기 때문에 사용할때 ';'나눠서 선택적으로 가져와야한다.
      const cookies = document.cookie.split('; ').map(el => el.split('='));
      const getItem = [];

      for (let i = 0; i < cookies.length; i++) {
        // 해당하는 key를 갖는 쿠키데이터를 찾기위해 반복문을 사용했는데 다른방법도 연구해봐야겠다.
        if (cookies[i][0] === key) {
          getItem.push(cookies[i][1]);
          break;
        }
      }

      if (getItem.length > 0) {
        return JSON.parse(getItem[0]);
      }
    },

    getNoDataMsg() {
      return this.$i18n.t('sdl.common.message.noResult');
    },

    getTimeStampGmt(msg) {
      const now = new Date();
      const gmt = (now.getTimezoneOffset() / 60) * -1;
      const accDate = this.$i18n.t(msg, {
        gmt,
      });
      return accDate;
    },

    getTimezone(accessDate) {
      if (accessDate === '-') {
        return accessDate;
      }
      const bfDate = new Date(accessDate);
      const now = new Date();
      const gmt = now.getTimezoneOffset() * -1;
      this.gmt = gmt / 60;
      const logDate = new Date(bfDate.getTime() + gmt * 60 * 1000);
      return this.dateFomat(logDate);
    },

    dateFomat(logDate) {
      const fomat = `${logDate.getFullYear()}-${
        logDate.getMonth() + 1 < 10 ? `0${logDate.getMonth() + 1}` : logDate.getMonth() + 1
      }-${logDate.getDate() < 10 ? `0${logDate.getDate()}` : logDate.getDate()} ${
        logDate.getHours() < 10 ? `0${logDate.getHours()}` : logDate.getHours()
      }:${logDate.getMinutes() < 10 ? `0${logDate.getMinutes()}` : logDate.getMinutes()}:${
        logDate.getSeconds() < 10 ? `0${logDate.getSeconds()}` : logDate.getSeconds()
      }`;
      return fomat;
    },

    // 뒤에 공백 제거
    trimCharsEnd(str) {
      if (_.isEmpty(str)) return str;
      return str.replace(/\s*$/, '');
    },

    // Master User Name 특수문자 제거(.-_ 예외)
    masterUserNameValidStr(str) {
      const spStr = str.replaceAll(/([\-a-zA-Z0-9ㄱ-ㅎ._]+)/g, '');
      for (const c of spStr) {
        str = str.replaceAll(c, '');
      }

      return str;
    },

    checkCidr(cidr) {
      if (!cidr) return false;
      const pattern = new RegExp(
        '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/(?:3[0-1]$|[1-2][0-9]$|\\d{1}$)',
      );
      if (!pattern.test(cidr)) {
        const msg = this.$i18n.t('cop.rem.scopCidr.message.ip', { cidr });
        // setTimeout(()=>SDLUtil.alert(msg), 300);
        SDLUtil.alert(msg);
        return true;
      }
      return false;
    },

    popupClose() {
      SDLUtil.confirm({
        msg: 'cop.rem.message.confirm.closePop',
        title: 'sdl.common.label.confirm',
        okLabel: 'sdl.common.label.confirm',
        cancelLabel: 'sdl.common.label.cancel',
        onOkEvt: () => {
          this.$emit('close');
        },
      });
    },

    getAccessType(reqTypeCd) {
      return Constants.ACCESS_TYPE[reqTypeCd];
    },

    getRole(acsTypeCd) {
      return Constants.USER_ROLE[acsTypeCd];
    },

    getPersonalData(cd) {
      return Constants.PERSONAL_DATA[cd];
    },
    getRequestType(cd) {
      return Constants.ACCESS_TYPE[cd];
    },

    displayUserName(userName, knoxId) {
      if (!_.isEmpty(userName)) return `${userName} (${knoxId})`;
    },

    getDivisionNm(divisionCd) {
      return this.getRemDivisionList.find(division => division.divisionCd === divisionCd);
    },

    isObtuseContain(source, target) {
      if (_.isEmpty(source) || _.isEmpty(target)) return false;

      if (target === 'mysql') {
        console.log('@@1 : ', source.toLowerCase());
        console.log('@@2 : ', source.toLowerCase().indexOf(target));
      }

      return source.toLowerCase().indexOf(target) !== -1;
    },

    isStorage(rsrcTypeCd) {
      return rsrcTypeCd === 'S3' || rsrcTypeCd === 'DYNAMODB' || rsrcTypeCd === 'STORAGE ACCOUNT';
    },

    isSvrOrDB(rsrcTypeCd) {
      return rsrcTypeCd === 'EC2' || rsrcTypeCd === 'RDS';
    },

    getRemoveArray(removeArray, originalArray) {
      const array = Object.assign([], originalArray);

      if (removeArray.length > 0 && array.length > 0) {
        for (let i = 0; i < removeArray.length; i += 1) {
          const removeVal = removeArray[i];
          for (let j = 0; j < array.length; j += 1) {
            if (array[j] === removeVal) {
              array.splice(j, 1);
            }
          }
        }
      }
      return array;
    },

    isProcessEnvProd() {
      return process.env.NODE_ENV === 'prod';
    },

    isRemEmpty(obj) {
      return _.isEmpty(obj);
    },

    mNow(format = 'YYYYMMDD_HHmmss') {
      return moment().format(format);
    },

    ynToYesNo(yn) {
      if (yn === 'Y') return 'YES';
      return 'NO';
    },

    isMainCsp(cspCd) {
      return cspCd === 'aws' || cspCd === 'azure' || cspCd === 'gcp' || cspCd === 'aws_cn' || cspCd === 'azure_cn';
    },

    getLinkVpcPeering(cspCd) {
      if (cspCd === 'ncp') return '/static/manual/SCOP_Manual_en/index.html#3828fa21ce0271a3';
      if (cspCd === 'oci') return '/static/manual/SCOP_Manual_en/index.html#f51409086849a88f';
      if (cspCd === 'scp') return '/static/manual/SCOP_Manual_en/index.html#15ff7faa5d7be6a2';
      if (cspCd === 'ali' || cspCd === 'ali_cn') return '/static/manual/SCOP_Manual_en/index.html#2e4c1cb177e77789';
      return '/static/manual/SCOP_Manual_en/index.html#3828fa21ce0271a3';
    },

    getLinkSG(cspCd) {
      if (cspCd === 'ncp') return '/static/manual/SCOP_Manual_en/index.html#f4776486aa5d3eef';
      if (cspCd === 'oci') return '/static/manual/SCOP_Manual_en/index.html#37adbf81c8bea832';
      if (cspCd === 'scp') return '/static/manual/SCOP_Manual_en/index.html#38870dba67828682';
      if (cspCd === 'ali' || cspCd === 'ali_cn') return '/static/manual/SCOP_Manual_en/index.html#df5126cf0ba3d083';
      return '/static/manual/SCOP_Manual_en/index.html#109c5b50ec0f74eb';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/RemCommon.js